<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('badge_edit')">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-police-badge</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-badge-show">
      <v-img
        class = "ma-2"
        max-height="350"
        max-width="350"
        contains
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('badge_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('administration.user.users') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['users']" :key="_item.id">
                    {{ _item.login }}
                  </li>
                </ul>

              </td>

            </tr>


          </tbody>
        </template>
      </v-simple-table>
    </div>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';
const servicePrefix = 'Badge';

export default {
  name: 'BadgeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm
  },
  data: () => ({
    filter: '',
    changeLogData: null,
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('badge', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('badge', ['find']),
    ...mapGetters('badge',{
      dataAccessory: 'data',
    }),
    ...mapState('badge', {
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
  },
  methods: {
    ...mapActions('badge', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
  }
};
</script>
